<template>
  <b-card class="faq">
    <div class="d-flex justify-content-between">
      <h5 class="card-title">{{ title }}</h5>
      <span class="text-main2 pointer" @click="$emit('onClickTag', topic)">{{ topic }}</span>
    </div>
    <b-card-text>
      <p class="card-content" v-html="content"></p>
    </b-card-text>
  </b-card>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: 'title',
    },
    topic: {
      type: String,
      default: 'topic',
    },
    content: {
      type: String,
      default: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    },
  },
};
</script>
<style lang="scss">
.card.faq {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 6px;
  border: none;

  .card-title {
    margin-bottom: 1rem;
  }

  .card-content {
    img {
      width: 100%;
      object-fit: 'contain';
    }
  }

}
</style>
